import Component from "../../lib/component";
import {copyTextToClipboard} from "../../helpers/clipboard";

export const ClipboardCopyConfig = {
    componentTypeKey: 'ClipboardCopy',
    baseHtmlClass: 'js--clipboard_copy',
    selector: '.js--clipboard_copy',

    datasetConfigKey: 'clipboard_copy__config',
    sourceTextDatasetConfigKey: 'source_text',
    sourceElementDatasetConfigKey: 'source_element',

    resetTimeout: 3000,
};

/**
 * The ClipboardCopy component adds a click event to the element so that it will place the source text in the clipboard.
 */
export class ClipboardCopy extends Component {

    static get config() {
        return ClipboardCopyConfig;
    }

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ClipboardCopyConfig
        });

        this.originalText = this.element.textContent;

        this.setDatasetConfig(ClipboardCopyConfig.datasetConfigKey);
        this.sourceText = this.getSourceText();
        this.sourceElement = this.getSourceElement();

        this.copied = false;

        this.element.addEventListener('click', this.handleClick.bind(this));

        // Watch for changes on the sourceElement - which means any copied value is no longer represented in the source element.
        if (this.sourceElement) {
            this.sourceElement.addEventListener('input', () => {
                this.copied = false;
                this.render();
            });
        }

        this.render();
    }

    handleClick() {
        this.doCopy().then(
            this.handleCopySuccess.bind(this),
            this.handleCopyFail.bind(this)
        );
    }

    async doCopy() {
        this.text = this.textForClipboard();
        return this.copied = await copyTextToClipboard(this.text);
    }

    handleCopySuccess() {
        console.log("[ClipboardCopy] Copied source text to the clipboard!", this.text);
        this.render();
        window.setTimeout(this.resetCopyState.bind(this), ClipboardCopy.config.resetTimeout);
    }

    handleCopyFail(error) {
        console.error("[ClipboardCopy] Failed to copy to the clipboard!", error);
        this.render();
        window.setTimeout(this.resetCopyState.bind(this), ClipboardCopy.config.resetTimeout);
    }

    resetCopyState() {
        this.copied = false;
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.copied, 'copied');
        this.element.textContent = this.copied ? 'Copied!' : this.originalText;
    }

    getSourceText() {
        return this.getDatasetConfigValue(ClipboardCopyConfig.sourceTextDatasetConfigKey);
    }

    getSourceElement() {
        const id = this.getDatasetConfigValue(ClipboardCopyConfig.sourceElementDatasetConfigKey);
        if (!id) return;
        return document.getElementById(id);
    }

    textForClipboard() {
        if (this.sourceText) {
            return this.sourceText
        }
        if (this.sourceElement) {
            return this.sourceElement.value || this.sourceElement.innerText;
        }
    }

}
